import React, { useEffect, useMemo, useState, useLayoutEffect } from 'react';
// import "../Transactions/salesinvoice.scss"
import axios from '../../axios';
import moment from 'moment';
import numeral from 'numeral';
import SweetAlert from 'react-bootstrap-sweetalert';
import Select from 'react-select';
import { makeStyles } from '@material-ui/core/styles';
import Spinner from 'react-spinkit';
import Backdrop from '@material-ui/core/Backdrop';
// import Breadcrumbs from "../../components/Common/Breadcrumbs"
// import DeleteModal from "../../components/Common/DeleteModal"
// import TableRows from "../../components/Common/TableRows"
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
// import TableContainer from "../../components/Common/TableContainer"
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { saveAs } from 'file-saver';
import Switch from 'react-switch';
import { styled } from '@mui/system';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Divider,
  Tooltip,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Table,
  TableBody,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import { Stack } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  CardTitle,
  ModalHeader,
  ModalBody,
  Form,
  Card,
  Input,
  Container,
  // Table,
  FormFeedback,
  Label,
  CardBody,
  Button,
  ModalFooter,
} from 'reactstrap';
import { set } from 'lodash';
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  dialogpaper: {
    width: '1200px',
  },
}));

const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: '#3468C0',
  color: '#yourCustomTextColor',
  '&:hover': {
    backgroundColor: '#2c3e50',
  },
});

function BranchMaster({
  ShowModalProps,
  isEditProps,
  ComponentProps,
  Callback,
  EditIdProps,
  ReturnCallBack,
}) {
  const [modal, setModal] = useState(false);

  const [Active, setActive] = useState(true);
  const [Default, setDefault] = useState(false);
  const [deletemsg, setdeletemsg] = useState(false);
  const [CityErr, setCityErr] = useState(false);

  const [Department, setDepartment] = useState('');
  const [BranchName, setBranchName] = useState('');

  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );
  const [BranchMasterData, setBranchMasterData] = useState([]);
  // const [BranchMasterData, setBranchMasterData] = useState([])
  const history = useHistory();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletid, setdeletid] = useState('');
  const [deletepopup, setdeletepopup] = useState(false);
  const [dailoa1, setdailoa1] = useState(false);
  const classes = useStyles();

  const [edit, setedit] = useState(false);
  const [Departmentid, setDepartmentid] = useState('');
  //err
  const [ContactNumbererr, setContactNumbererr] = useState(false);
  const [added, setadded] = useState(false);
  const [duplicateerr, setduplicateerr] = useState(false);
  const [updated, setupdated] = useState(false);

  const [ContactNumber, setContactNumber] = useState('');
  const [Driverid, setDriverid] = useState('');
  const [drivername, setdrivername] = useState('');
  const [DriverNameErr, setDriverNameErr] = useState(false);

  //companyhelp
  const [CompanyCollection, setCompanyCollection] = useState([]);
  const [CompanyCollection1, setCompanyCollection1] = useState([]);
  const [companyNameHelp, setcompanyNameHelp] = useState({
    label: sessionStorage.getItem('companyName'),
    value: sessionStorage.getItem('Companyid'),
  });

  const [ContactPerson, setContactPerson] = useState('');
  const [Address1, setAddress1] = useState('');
  const [Address2, setAddress2] = useState('');
  const [pincode, setpincode] = useState('');
  const [city, setcity] = useState('');
  const [statecode, setstatecode] = useState('');
  const [BranchCode, setBranchCode] = useState('');
  const [country, setcountry] = useState('');
  const [phone, setphone] = useState('');
  const [Emailid, setEmailid] = useState('');
  const [FaxNo, setFaxNo] = useState('');
  const [distance, setdistance] = useState('0');
  const [Gstin, setGstin] = useState('');
  const [Panno, setPanno] = useState('');

  const [allstatecollections, setallstatecollections] = useState([]);
  const [onestatedefaultvalue, setonestatedefaultvalue] = useState({
    label: 'Select...',
    value: '',
  });
  const [warehouseid, setwarehouseid] = useState('');

  //validationerr
  const [Branchnameerr, setBranchnameerr] = useState(false);
  // const [ledgernameerr, setledgernameerr] = useState(false)
  const [companynameerr, setcompanynameerr] = useState(false);
  const [Adress1err, setAdress1err] = useState(false);
  const [contactpersonerr, setcontactpersonerr] = useState(false);
  const [pincodeerr, setpincodeerr] = useState(false);
  const [validpincodeerr, setvalidpincodeerr] = useState(false);

  //ledgerhelp
  const [customerNameHelpData, setcustomerNameHelpData] = useState([]);
  const [customerNameHelpData1, setcustomerNameHelpData1] = useState([]);
  const [customerNameHelp, setcustomerNameHelp] = useState({
    label: 'All',
    value: 0,
  });

  const [ledgernameerr, setledgernameerr] = useState(false);

  //Countryhelp
  const [allcountrycollections, setallcountrycollections] = useState([]);
  const [onecountrydefaultvalue, setonecountrydefaultvalue] = useState({
    label: 'India',
    value: 2,
  });

  //city
  const [allcitycollections, setallcitycollections] = useState([]);
  const [onecitydefaultvalue, setonecitydefaultvalue] = useState({
    label: 'Select...',
    value: '',
  });

  const pages = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  const [branchid, setbranchid] = useState('');

  const [deletedconfirm, setdeletedconfirm] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');

  useLayoutEffect(() => {
    Getallcity();
    Getallcountrys();
    GetLedgerHelp();
    GetAllBranchMasterData();
    GetallCompany();
    Getallstate();
    Getonestates();
  }, [ReturnCallBack]);

  useEffect(() => {
    console.log(ShowModalProps, 'ShowModalProps');
    console.log(isEditProps, 'isEditProps');
    if (ComponentProps) {
      if (isEditProps) {
        editquotationComponent();
      } else {
        setedit(false);
      }
      if (ShowModalProps) {
        setModal(ShowModalProps);
      }
    }
  }, [ReturnCallBack]);

  const handleOnClose = (value, value1) => {
    Callback(value, value1);
    console.log(value1);
  };

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const changepage = () => {
    return BranchMasterData.slice(page * rowsperpage, (page + 1) * rowsperpage);
  };

  const editquotationComponent = async () => {
    try {
      const get = await axios.instance
        .get(
          `/GetoneBranchMastData/${EditIdProps}/${sessionStorage.getItem(
            'Companyid',
          )}`,
          {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          for (const col of res.data) {
            setBranchName(col.branch_name);
            setBranchCode(col.branch_code);
            setcustomerNameHelp({
              label: col.customer_name,
              value: col.customer_id,
            });
            setContactPerson(col.contact_person);
            setAddress1(col.address1);
            setAddress2(col.address2);
            setpincode(col.area_code);
            setonecitydefaultvalue({ label: col.city, value: '' });
            setstatecode(col.statecode);
            setonecountrydefaultvalue({ label: col.country, value: '' });
            setphone(col.phone);
            setEmailid(col.emailid);
            setFaxNo(col.fax);
            setGstin(col.tin_no);
            setPanno(col.panno);
            setdistance(col.distance);
            setbranchid(col.branch_id);
          }
        });

      setModal(true);
      setedit(true);
      // toggle()
    } catch {
      //  toastr.warning("No Data Found ", "Terms & Conditions")
    }
  };

  const Getonestates = async () => {
    const get = await axios.instance
      .get(`/Getonestate/${sessionStorage.getItem('StateCode')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        // setallstatecollections(res.data)
        for (const data of res.data) {
          setonestatedefaultvalue({
            label: data.StateName,
            value: data.StateId,
          });
          const formattedStateCode =
            parseInt(data.StateId) < 10
              ? `0${data.StateId}`
              : `${data.StateId}`;
          // validation.values.GSTNo = formattedStateCode;
          setGstin(formattedStateCode);
          setstatecode(data.StateCode);
        }
      });
  };

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  };

  // if (edit) {
  // setedit(true)
  // } else {
  // setedit(false)
  // }

  const GetAllBranchMasterData = async () => {
    setdailoa1(true);
    const get = await axios.instance
      .get(`/GetAllBranchMastData/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        setBranchMasterData(res.data);
      });
    setTimeout(() => {
      setdailoa1(false);
    }, 1000);
  };

  const GetallCompany = async () => {
    const Getcom = await axios.instance
      .get('/GetallCompany', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        setCompanyCollection(res.data);
        const data = res.data;
        const options = data.map(b => ({
          label: b.Company_Name,
          value: b.Company_Id,
        }));
        setCompanyCollection1(options);
      });
  };

  const GetLedgerHelp = async () => {
    const get = await axios.instance
      .get(`/GetallCustomerHelp/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        setcustomerNameHelpData1(res.data);
        const data = res.data;
        const options = data.map(b => ({
          label: b.customer_name,
          value: b.customer_id,
        }));
        options.push({ label: 'All', value: '0' });
        setcustomerNameHelpData(options);
      });
  };

  const Getallcountrys = async () => {
    const get = await axios.instance
      .get('/Getallcountry', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        const data = res.data;
        const options = data.map(b => ({
          label: b.CountryName,
          value: b.CountryId,
        }));

        setallcountrycollections(options);
      });
  };

  const Getallcity = async () => {
    const get = await axios.instance
      .get('/Getallcity', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        const data = res.data;
        const options = data.map(b => ({
          label: b.City_Name,
          value: b.City_Id,
        }));

        setallcitycollections(options);
      });
  };

  const editquotation = col => {
    console.log('edit Data', col);
    toggle();
    setedit(true);
    setBranchName(col.branch_name);
    setBranchCode(col.branch_code);
    setcustomerNameHelp({ label: col.customer_name, value: col.customer_id });
    setContactPerson(col.contact_person);
    setAddress1(col.address1);
    setAddress2(col.address2);
    setpincode(col.area_code);
    setonecitydefaultvalue({ label: col.city, value: '' });
    setstatecode(col.statecode);
    setonecountrydefaultvalue({ label: col.country, value: '' });
    setphone(col.phone);
    setEmailid(col.emailid);
    setFaxNo(col.fax);
    setGstin(col.tin_no);
    setPanno(col.panno);
    setdistance(col.distance);
    // setActive(col.active==='Y' ? true : false)
    // setDefault(col.defultwh==='Y' ? true : false)
    // setwarehouseid(col.warehouse_id)
    setbranchid(col.branch_id);
  };

  const toggledeletemodal = id => {
    setDeleteModal(true);
    setdeletid(id);
  };

  const Deletequotation = async () => {
    const get1 = await axios.instance
      .post(
        `/InsertBranchMasterData`,
        {
          Branch_Id: deletid,
          Optype: 'Delete',
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        const data = res.data;

        // for(const i of data){
        // setid(i.Brand_Id)
        if (data.length === 1) {
          setDeleteModal(false);
          setdeletepopup(true);
          GetAllBranchMasterData();
        } else {
          setDeleteModal(false);
          setdeletemsg(true);
        }
        // }
      });
  };

  // filter

  // const filteredData = BranchMasterData.filter(data => {
  //   const matchesFilters = Object.keys(selectedFilters).every(filter => {
  //     return !selectedFilters[filter] || data[filter] === 'Y';
  //   });

  //   const matchesSearchQuery = data.branch_name.toLowerCase().includes(
  //     searchQuery.toLowerCase(),
  //   );

  //   return matchesFilters && matchesSearchQuery;
  // });

  // const handleFilterChange = filter => {
  //   setSelectedFilters(prevFilters => ({
  //     ...prevFilters,
  //     [filter]: !prevFilters[filter],
  //   }));
  // };

  const columns = useMemo(
    () => [
      {
        Header: 'Branch Name',
        accessor: 'branch_name',
        disableFilters: true,
        filterable: false,
      },
      {
        Header: 'Customer Name',
        accessor: 'customer_name',
        disableFilters: true,
        filterable: false,
      },
      {
        Header: 'Contact Person',
        accessor: 'contact_person',
        disableFilters: true,
        filterable: false,
      },
      {
        Header: 'Phone',
        accessor: 'phone',
        disableFilters: true,
        filterable: false,
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Tooltip title="Edit" placement="left-start">
                <Link
                  to="#"
                  className="text-primary"
                  onClick={() => {
                    const po = cellProps.row.original;
                    editquotation(po);
                  }}
                >
                  <i
                    className="uil uil-pen font-size-18"
                    id="edittooltip"
                    style={{ color: 'blue' }}
                  />
                </Link>
              </Tooltip>
              <Tooltip title="Delete" placement="right-end">
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => {
                    if (
                      JSON.parse(
                        sessionStorage.getItem(
                          'MenuItemCustomerBranchControls',
                        ),
                      ).Del == 'Y'
                    ) {
                      const po = cellProps.row.original;
                      toggledeletemodal(po.branch_id);
                    } else {
                      toastr.warning(
                        'Please Contact Admin',
                        'Operation Not Allowed',
                      );
                    }
                  }}
                >
                  <i
                    className="uil uil-trash-alt font-size-18"
                    id="deletetooltip"
                  />
                </Link>
              </Tooltip>
            </div>
          );
        },
      },
    ],
    [],
  );

  const InsertBranchMasterData = async () => {
    if (edit === false) {
      console.log(
        BranchName.length,
        customerNameHelp.value,
        ContactPerson.length,
        pincode.length,
        onecitydefaultvalue.label,
        BranchName.length != 0 &&
          // customerNameHelp.value != 0 &&
          ContactPerson.length != 0 &&
          pincode.length != 0 &&
          onecitydefaultvalue.label != '',
      );
      if (
        BranchName.length != 0 &&
        // customerNameHelp.value != 0 &&
        ContactPerson.length != 0 &&
        pincode.length != 0 &&
        onecitydefaultvalue.label != ''
      ) {
        const get1 = await axios.instance
          .post(
            `/InsertBranchMasterData`,
            {
              Branch_Id: '',
              Branch_Name: BranchName,
              Branch_Code: BranchCode,
              Customer_Id: customerNameHelp.value,
              Contact_Person: ContactPerson,
              Address1: Address1,
              Address2: Address2,
              Area_Code: pincode,
              City: onecitydefaultvalue.label,
              Zip_Code: pincode,
              State: onestatedefaultvalue.label,
              Country: onecountrydefaultvalue.label,
              Phone: phone,
              Fax: FaxNo,
              EmailId: Emailid,
              TIN_No: Gstin,
              Created_By: 1,
              Created_Date: moment(new Date()).format('YYYY-MM-DD'),
              StateCode: statecode,
              StateId: statecode,
              PANNo: Panno,
              Distance: distance,
              Optype: 'New',
            },
            {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            if (res.data.length === 1) {
              toggle();
              setadded(true);
              GetAllBranchMasterData();
              setBranchName('');
              setBranchCode('');
              setcustomerNameHelp({ label: 'All', value: 0 });
              setContactPerson('');
              setAddress1('');
              setAddress2('');
              setpincode('');
              // setonecitydefaultvalue({ label: "Chennai", value: 6 })
              //setonestatedefaultvalue({ label: "Tamil Nadu", value: 33 })
              // setstatecode("33")
              setonecountrydefaultvalue({ label: 'India', value: 2 });
              setphone('');
              setEmailid('');
              setFaxNo('');
              // setActive(true)
              // setDefault(false)
              setPanno('');
              setdistance('0');
              setGstin('');
              if (ComponentProps) {
                handleOnClose(true, 'New');
              }
            } else {
              setduplicateerr(true);
              if (ComponentProps) {
                handleOnClose(true, 'Error');
              }
            }
          });
      } else {
        if (BranchName.length === 0) {
          setBranchnameerr(true);
        }
        if (onecitydefaultvalue.label === '') {
          setCityErr(true);
        }
        if (customerNameHelp.value === 0) {
          setledgernameerr(true);
        }
        if (ContactPerson.length === 0) {
          setcontactpersonerr(true);
        }
        if (pincode.length === 0) {
          setpincodeerr(true);
        }
        // if(pincode.length>=6){
        //     setvalidpincodeerr(true)
        // }
        setTimeout(() => {
          setBranchnameerr(false);
          setcontactpersonerr(false);
          setledgernameerr(false);
          setpincodeerr(false);
          setCityErr(false);
          // setvalidpincodeerr(false)
          // setAdress1err(false)
        }, 2000);
      }
    } else {
      console.log(
        BranchName.length != '' &&
          customerNameHelp.value != 0 &&
          ContactPerson.length != '' &&
          pincode.length != '',
      );
      if (
        BranchName.length != 0 &&
        // customerNameHelp.value != 0 &&
        ContactPerson.length != 0 &&
        pincode.length != 0 &&
        onecitydefaultvalue.label != ''
      ) {
        const get1 = await axios.instance
          .post(
            `/InsertBranchMasterData`,
            {
              Branch_Id: branchid,
              Branch_Name: BranchName,
              Branch_Code: BranchCode,
              Customer_Id: customerNameHelp.value,
              Contact_Person: ContactPerson,
              Address1: Address1,
              Address2: Address2,
              Area_Code: pincode,
              City: onecitydefaultvalue.label,
              Zip_Code: pincode,
              State: onestatedefaultvalue.label,
              Country: onecountrydefaultvalue.label,
              Phone: phone,
              Fax: FaxNo,
              EmailId: Emailid,
              TIN_No: Gstin,
              Created_By: 1,
              Created_Date: moment(new Date()).format('YYYY-MM-DD'),
              StateCode: statecode,
              StateId: statecode,
              PANNo: Panno,
              Distance: distance,
              Optype: 'Edit',
            },
            {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            if (res.data.length === 1) {
              toggle();

              setupdated(true);
              GetAllBranchMasterData();
              setBranchName('');
              setBranchCode('');
              setcustomerNameHelp({ label: 'All', value: 0 });
              setContactPerson('');
              setAddress1('');
              setAddress2('');
              setpincode('');
              // setonecitydefaultvalue({ label: "Chennai", value: 6 })
              // setonestatedefaultvalue({ label: "Tamil Nadu", value: 33 })
              // setstatecode("33")
              //  setonecountrydefaultvalue({ label: "India", value: 2 })
              setphone('');
              setEmailid('');
              setFaxNo('');
              // setActive(true)
              // setDefault(false)
              setPanno('');
              setdistance('0');
              setGstin('');
              if (ComponentProps) {
                handleOnClose(true, 'Edit');
              }
            } else {
              setduplicateerr(true);
              if (ComponentProps) {
                handleOnClose(true, 'Error');
              }
            }
          });
      } else {
        if (BranchName.length === 0) {
          setBranchnameerr(true);
        }
        if (customerNameHelp.value === 0) {
          setledgernameerr(true);
        }
        if (ContactPerson.length === 0) {
          setcontactpersonerr(true);
        }
        if (pincode.length === 0) {
          setpincodeerr(true);
        }
        // if(pincode.length>=6){
        //     setvalidpincodeerr(true)
        // }
        setTimeout(() => {
          setBranchnameerr(false);
          setcontactpersonerr(false);
          setledgernameerr(false);
          setpincodeerr(false);
          // setvalidpincodeerr(false)
          // setAdress1err(false)
        }, 2000);
      }
    }
  };

  const Getallstate = async () => {
    const get = await axios.instance
      .get('/GetallStates', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        const data = res.data;
        const options = data.map(b => ({
          label: b.StateName,
          value: b.StateId,
        }));

        setallstatecollections(options);
      });
  };

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => Deletequotation()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}

      <div className="page-content" style={{ backgroundColor: 'inherit' }}>
        <div className="">
          {!ComponentProps && (
            <Row>
              <Col xs="12">
                <h6 className="titleviewinspections">Customer Branch</h6>
                <Card>
                  <CardBody>
                    <div className="mt-2">
                      {/* <Breadcrumbs
                        title="Master"
                        breadcrumbItem="Customer Branch"
                      /> */}
                    </div>
                    <Divider sx={{ mb: 2 }} />
                    <div className="d-flex justify-content-end mt-2">
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          toggle();
                        }}
                        size="small"
                      >
                        Add Customer Branch
                      </CustomButton>
                    </div>
                    {/* <div className="d-flex justify-content-between align-items-center mt-2">
                   
                      <Col lg="4">
                        <Stack
                          direction={{ sm: "row", xs: "column" }}
                          spacing={2}
                          justifyContent="start"
                          alignItems="center"
                          pt={1}
                        >
                          <TextField
                            variant="outlined"
                            size="small"
                            className="p-0"
                            placeholder="Search Customer"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon fontSize="small" />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                      </Col>

                     
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          toggle();
                        }}
                        size="small"
                      >
                        Add Customer Branch
                      </CustomButton>
                    </div> */}

                    {/* <TableContainer
                      columns={columns}
                      data={BranchMasterData}
                      isGlobalFilter={true}
                      isAddOrder={true}
                      isAddTableWithoutBorderStrap={true}
                    /> */}
                    <div>
                      {/* <Card className="">
                        <CardBody> */}
                      <div className="Tabelinspections">
                        <TableContainer>
                          <Table className="InspectionTbls">
                            <TableHead>
                              <TableRow>
                                <TableCell>Branch Name </TableCell>
                                <TableCell align="left">
                                  Customer Name
                                </TableCell>
                                <TableCell align="left">
                                  Contact Person
                                </TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Edit</TableCell>
                                <TableCell>Delete</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {BranchMasterData.length != 0 ? (
                                changepage().map(data => (
                                  <TableRow key={data.Order_Id}>
                                    <TableCell style={{ textAlign: 'left' }}>
                                      {data.branch_name}
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'left' }}>
                                      {data.customer_name}
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'left' }}>
                                      {data.contact_person}
                                    </TableCell>
                                    <TableCell>{data.phone}</TableCell>
                                    <TableCell align="left">
                                      <IconButton size="small">
                                        {/* <VisibilityIcon fontSize="small"  */}
                                        <EditIcon
                                          fontSize="small"
                                          color="primary"
                                          onClick={() => {
                                            // editdata(data);
                                            console.log(data);
                                            // setdeleteid(data.Termsid);
                                            // setisedit(true);
                                            editquotation(data);
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell align="left">
                                      <IconButton size="small">
                                        <DeleteIcon
                                          color="error"
                                          fontSize="small"
                                          onClick={() => {
                                            // setdeletedconfirm(true);
                                            // setdeleteid(data.Termsid);
                                            setdeletedconfirm(true);
                                            // toggledeletemodal(data.branch_id)
                                            setdeletid(data.branch_id);
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableCell align="left">
                                  NO Data Found
                                </TableCell>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <TablePagination
                          component="div"
                          rowsPerPageOptions={pages}
                          count={BranchMasterData.length}
                          rowsPerPage={rowsperpage}
                          page={page}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </div>
                      {/* <Backdrop open={open}>
                            <Spinner name="ball-spin-fade-loader" color="#fafafa" />
                            <p style={{ marginTop: '50px' }}></p>
                          </Backdrop> */}
                      {/* </CardBody>
                      </Card> */}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader
              toggle={() => {
                toggle();

                setedit(false);
                setBranchName('');
                setBranchCode('');
                setcustomerNameHelp({ label: 'All', value: 0 });
                setContactPerson('');
                setAddress1('');
                setAddress2('');
                setpincode('');
                setonecitydefaultvalue({
                  label: 'Select...',
                  value: '',
                });
                //setonestatedefaultvalue({ label: "Tamil Nadu", value: 33 })
                //  setstatecode("33")
                setonecountrydefaultvalue({ label: 'India', value: 2 });
                setphone('');
                setEmailid('');
                setFaxNo('');
                // setActive(true)
                // setDefault(false)
                setPanno('');
                setdistance('0');
                setGstin('');
                // setonestatedefaultvalue({label:"Tamil Nadu",value:33})
              }}
              tag="h4"
            >
              {edit === true ? 'Edit Customer Branch' : 'Add Customer Branch'}
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg="3">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">Branch Code</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={BranchCode}
                      disabled
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setBranchCode(e.target.value);
                      }}
                    />
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">
                      Branch Name <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={BranchName}
                      onChange={e => {
                        setBranchName(e.target.value);
                      }}
                    />
                    {Branchnameerr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Branch Name
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-2">
                    <Label htmlFor="manufacturerbrand">
                      <b>Ledger </b> <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Select
                      options={customerNameHelpData}
                      classNamePrefix="select2-search-disable"
                      // defaultValue={{'label' : 'All' , 'value' : '0'}}
                      value={customerNameHelp}
                      onChange={value => {
                        setcustomerNameHelp({
                          label: value.label,
                          value: value.value,
                        });
                      }}
                    />
                    {ledgernameerr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Select LedgerName
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">
                      Contact person <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={ContactPerson}
                      onChange={e => {
                        setContactPerson(e.target.value);
                      }}
                    />
                    {contactpersonerr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Contact Person
                      </p>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">Address1</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={Address1}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setAddress1(e.target.value);
                      }}
                    />
                    {Adress1err == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Address
                      </p>
                    ) : null}
                  </div>
                </Col>
                {/* <Col xl={2}>
                    <h5 className="font-size-14 mt-1">
                        Default 
                    </h5>
                    
                        <div className="mt-2">
                           
                                
                            <Switch 
                                onChange={(checked)=>{
                                    {checked?
                                    setDefault(true)
                                    :
                                    setDefault(false)
                                    }
                                  
                                }} 
                                checked={Default} 
                            
                                width={40}
                                height={20}
                            /> 
                          
                        
                        </div>                                              
                </Col>                */}
              </Row>
              <Row>
                <Col lg="12">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">Address2</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={Address2}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setAddress2(e.target.value);
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="3">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">
                      Pin Code <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={pincode}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setpincode(e.target.value);
                      }}
                    />
                    {pincodeerr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter PinCode
                      </p>
                    ) : null}
                  </div>
                </Col>
                {/* <Col lg="3">
                        <div className="mb-2">
                        <Label  for="basicpill-firstname-input1">
                        City

                    </Label>
                        <Input
                            autoComplete="off"
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            name="Product_Details_Description"
                            value={city}
                            onChange={(e)=>{
                                // setDepartment(e.target.value)  
                                setcity(e.target.value)                                                  
                             
                                                        
                                
                            }}                                                
                        />
                        {
                            ContactNumbererr==true?<p style={{color:"red",fontSize:'12px'}}>Please Enter Contact Number</p>:null
                        }               
                        </div>
                </Col>  */}
                <Col lg="3">
                  <div className="mb-0">
                    <Label for="basicpill-email-input4">
                      City <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allcitycollections}
                      value={onecitydefaultvalue}
                      classNamePrefix="select2-search-disable"
                      onChange={value => {
                        setonecitydefaultvalue({
                          label: value.label,
                          value: value.value,
                        });
                      }}
                      // defaultValue={cityonedefaultvalue}
                    />
                  </div>
                  {CityErr ? (
                    <p style={{ fontSize: '12px' }} className="error">
                      Please Select City{' '}
                    </p>
                  ) : null}
                </Col>
                <Col lg="3">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">Distance</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={distance}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setdistance(e.target.value);
                      }}
                    />
                    {/* {
                            ContactNumbererr==true?<p style={{color:"red",fontSize:'12px'}}>Please Enter Contact Number</p>:null
                        }                */}
                  </div>
                </Col>
                <Col lg="3">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">GSTIN</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={Gstin}
                      maxLength={15}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setGstin(e.target.value);
                      }}
                    />
                    {/* {
                            ContactNumbererr==true?<p style={{color:"red",fontSize:'12px'}}>Please Enter Contact Number</p>:null
                        }                */}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="2">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">State Code</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={statecode}
                      disabled
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setstatecode(e.target.value);
                      }}
                    />
                    {ContactNumbererr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Contact Number
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="4">
                  <div className="mb-0">
                    <Label>
                      State <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allstatecollections}
                      classNamePrefix="select2-search-disable"
                      value={onestatedefaultvalue}
                      onChange={value => {
                        setonestatedefaultvalue({
                          label: value.label,
                          value: value.value,
                        });
                        const formattedStateCode =
                          parseInt(value.value) < 10
                            ? `0${value.value}`
                            : `${value.value}`;

                        setGstin(formattedStateCode);
                        setstatecode(value.value);
                      }}
                    />
                  </div>
                </Col>
                {/* <Col lg="6">
                        <div className="mb-2">
                        <Label  for="basicpill-firstname-input1">
                        Country 

                    </Label>
                        <Input
                            autoComplete="off"
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            name="Product_Details_Description"
                            value={country}
                            onChange={(e)=>{
                                // setDepartment(e.target.value)  
                                setcountry(e.target.value)                                                  
                            
                                      
                            }}                                                
                        />
                        {
                            ContactNumbererr==true?<p style={{color:"red",fontSize:'12px'}}>Please Enter Contact Number</p>:null
                        }               
                        </div>
                </Col>  */}
                <Col lg="6">
                  <div className="mb-0">
                    <Label>
                      Country <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allcountrycollections}
                      value={onecountrydefaultvalue}
                      classNamePrefix="select2-search-disable"
                      onChange={value => {
                        setonecountrydefaultvalue({
                          label: value.label,
                          value: value.value,
                        });
                      }}
                      // isDisabled
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="4">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">Phone</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={phone}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setphone(e.target.value);
                      }}
                    />
                    {ContactNumbererr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Contact Number
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="4">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">
                      Branch Prefix
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={FaxNo}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setFaxNo(e.target.value);
                      }}
                    />
                    {ContactNumbererr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Contact Number
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="4">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">PAN NO</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={Panno}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setPanno(e.target.value);
                      }}
                    />
                    {ContactNumbererr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Contact Number
                      </p>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <div className="mb-2">
                    <Label for="basicpill-firstname-input1">Email ID</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={Emailid}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setEmailid(e.target.value);
                      }}
                    />
                    {ContactNumbererr == true ? (
                      <p style={{ color: 'red', fontSize: '12px' }}>
                        Please Enter Contact Number
                      </p>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <ModalFooter>
                {edit === false ? (
                  <Button
                    style={{ backgroundColor: 'blue', color: 'white' }}
                    color="primary"
                    onClick={() => {
                      console.log(customerNameHelp.value);
                      if (customerNameHelp.value != 0) {
                        InsertBranchMasterData();
                      } else {
                        setledgernameerr(true);
                        setTimeout(() => {
                          setledgernameerr(false);
                        }, 3000);
                      }
                    }}
                  >
                    Save
                  </Button>
                ) : (
                  <Button
                    style={{ backgroundColor: 'blue', color: 'white' }}
                    color="primary"
                    onClick={() => {
                      // if (
                      //   JSON.parse(
                      //     sessionStorage.getItem("MenuItemCustomerBranchControls")
                      //   ).Edit == "Y"
                      // ) {
                      InsertBranchMasterData();
                      // toggle()
                      // setupdated(true)
                      // } else {
                      //   toastr.warning(
                      //     "Please Contact Admin",
                      //     "Operation Not Allowed"
                      //   )
                      // }
                    }}
                  >
                    Update
                  </Button>
                )}
              </ModalFooter>
            </ModalBody>
          </Modal>
        </div>
      </div>

      <Backdrop open={dailoa1} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>

      {deletepopup ? (
        <SweetAlert
          title="Customer Branch Deleted Successfully"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setdeletepopup(false);
          }}
        ></SweetAlert>
      ) : null}

      {deletemsg ? (
        <SweetAlert
          title="Transaction Found Can't Be Delete This Record"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setdeletemsg(false);
          }}
        ></SweetAlert>
      ) : null}

      {added ? (
        <SweetAlert
          title="Customer Branch Added Successfully"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setadded(false);
          }}
        ></SweetAlert>
      ) : null}

      {updated ? (
        <SweetAlert
          title="Customer Branch Updated Successfully"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setupdated(false);
          }}
        ></SweetAlert>
      ) : null}

      {duplicateerr ? (
        <SweetAlert
          title="Branch Name Already Exist"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setduplicateerr(false);
          }}
        ></SweetAlert>
      ) : null}

      {deletedconfirm ? (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            Deletequotation();
            setdeletedconfirm(false);
          }}
          onCancel={() => {
            setdeletedconfirm(false);
            // setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      ) : null}

      {/* {ledgernameerr ? (
        <SweetAlert
          title="Please Select Ledger"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setledgernameerr(false)
          }}
        ></SweetAlert>
      ) : null} */}
    </React.Fragment>
  );
}

export default BranchMaster;
